/**
 * Formats given duration in seconds in desired string format 00:00 or 00:00:00.
 * @param {*} seconds duration time to convert
 * @param {*} durationSeconds when given can force 00:00:00 format
 * @return {string} formatted duration time
 */
const durationFormat = (seconds, durationSeconds) => {
  if (!seconds || isNaN(seconds)) {
    return '00:00';
  }
  const date = new Date(null);
  date.setSeconds(seconds);
  if (seconds >= 3600 || durationSeconds >= 3600) {
    return date.toISOString().substr(11, 8);
  }
  return date.toISOString().substr(14, 5);
}
export default durationFormat;


// WEBPACK FOOTER //
// ./src/misc/duration-format/index.js